import React from 'react';
import { Archive, Trash } from 'react-feather';

function Notice({ children }: { children: React.ReactNode }) {
    return <div className="bg-saga-primary-light text-yellow-800 text-sm rounded-lg inline-block">{children}</div>;
}

Notice.Danger = function NoticeDanger({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-red-100 text-red-800 text-sm rounded-lg inline-block">
            <div className="py-2 px-3 flex items-center space-x-2">
                <Trash size={16} className="flex-shrink-0" />
                <div>{children}</div>
            </div>
        </div>
    );
};

Notice.Archived = function NoticeArchived({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-saga-gray-100 text-saga-text text-sm rounded-lg inline-block">
            <div className="py-2 px-3 flex items-center space-x-2">
                <Archive size={16} className="flex-shrink-0" />
                <div>{children}</div>
            </div>
        </div>
    );
};

export default Notice;
